import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row justify-content-center mt-4" }
const _hoisted_2 = { class: "col-md-5" }
const _hoisted_3 = { class: "card shadow-sm" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "text-center mb-3" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", { class: "mt-2 mb-0" }, "Alterar Senha", -1)
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Senha atual", -1)
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Nova senha", -1)
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Confirmar nova senha", -1)
const _hoisted_14 = { class: "d-flex gap-2" }
const _hoisted_15 = {
  key: 0,
  class: "mt-3 text-primary"
}
const _hoisted_16 = {
  key: 1,
  class: "mt-3 text-success"
}
const _hoisted_17 = {
  key: 2,
  class: "mt-3 text-danger"
}

import { reactive } from "vue";
import { useRouter } from "vue-router";
import * as empresaService from "@/services/empresaService";
import imgLogin from "@/assets/images/logoLogin.png";


export default /*#__PURE__*/_defineComponent({
  __name: 'AlterarSenha',
  setup(__props) {

const router = useRouter();

const controle = reactive({
  senhaAtual: "",
  senhaNova: "",
  senhaNovaConfirmacao: "",
  status: "",
  erro: "",
  sucesso: ""
});

function alterar() {
  controle.erro = "";
  controle.sucesso = "";

  if (!controle.senhaAtual || !controle.senhaNova || !controle.senhaNovaConfirmacao) {
    controle.erro = "Preencha todos os campos.";
    return;
  }

  if (controle.senhaNova !== controle.senhaNovaConfirmacao) {
    controle.erro = "Nova senha e confirmação não conferem.";
    return;
  }

  if (controle.senhaNova.length < 6) {
    controle.erro = "A nova senha deve ter pelo menos 6 caracteres.";
    return;
  }

  controle.status = "Alterando senha...";

  empresaService.alterarSenha(controle.senhaAtual, controle.senhaNova, controle.senhaNovaConfirmacao)
    .then((r) => {
      controle.status = "";
      controle.sucesso = r.mensagem || "Senha alterada com sucesso!";
      controle.senhaAtual = "";
      controle.senhaNova = "";
      controle.senhaNovaConfirmacao = "";
    })
    .catch((error) => {
      controle.status = "";
      controle.erro = error.message || "Erro ao alterar senha.";
    });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: _unref(imgLogin),
              alt: "Logo",
              class: "img-fluid",
              style: {"max-height":"60px"}
            }, null, 8, _hoisted_6),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              type: "password",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((controle.senhaAtual) = $event)),
              placeholder: "Digite sua senha atual"
            }, null, 512), [
              [_vModelText, controle.senhaAtual]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _withDirectives(_createElementVNode("input", {
              type: "password",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((controle.senhaNova) = $event)),
              placeholder: "Mínimo 6 caracteres"
            }, null, 512), [
              [_vModelText, controle.senhaNova]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _withDirectives(_createElementVNode("input", {
              type: "password",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((controle.senhaNovaConfirmacao) = $event)),
              placeholder: "Repita a nova senha"
            }, null, 512), [
              [_vModelText, controle.senhaNovaConfirmacao]
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary btn-sm",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (alterar()))
            }, "Salvar"),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary btn-sm",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push({ name: 'PainelEmpresa' })))
            }, "Voltar")
          ]),
          (controle.status)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(controle.status), 1))
            : _createCommentVNode("", true),
          (controle.sucesso)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(controle.sucesso), 1))
            : _createCommentVNode("", true),
          (controle.erro)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(controle.erro), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})